/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const costRateUpdate = /* GraphQL */ `
  mutation CostRateUpdate($input: UpdateCostRateInput!) {
    costRateUpdate(input: $input) {
      characterCostRate
      effectiveTimestamp
      id
      updatedBy
    }
  }
`;
export const reportScheduleUpdate = /* GraphQL */ `
  mutation ReportScheduleUpdate($input: UpdateReportScheduleInput!) {
    reportScheduleUpdate(input: $input) {
      format
      id
      recipients
      schedule
      updatedAt
      updatedBy
    }
  }
`;
export const sharedUpdatePreferences = /* GraphQL */ `
  mutation SharedUpdatePreferences(
    $visualDensity: String
    $visualMode: String
  ) {
    sharedUpdatePreferences(
      visualDensity: $visualDensity
      visualMode: $visualMode
    ) {
      visualDensity
      visualMode
    }
  }
`;
export const translationCreateJob = /* GraphQL */ `
  mutation TranslationCreateJob(
    $input: translation_createJob_input
    $limit: Int
    $nextToken: String
  ) {
    translationCreateJob(input: $input, limit: $limit, nextToken: $nextToken) {
      contentType
      createdAt
      id
      jobIdentity
      jobName
      jobOwner
      jobStatus
      languageSource
      languageTargets
      sourceKey
      sourceStatus
      translateCallback
      translateKey
      translateStatus
    }
  }
`;
export const usageCreateRecord = /* GraphQL */ `
  mutation UsageCreateRecord($input: CreateUsageRecordInput!) {
    usageCreateRecord(input: $input) {
      archived
      billingPeriod
      contentType
      costRateApplied
      estimatedCost
      id
      incomplete
      jobId
      jobType
      metricType
      metricValue
      sourceLanguage
      targetLanguageCount
      timestamp
      userId
      userName
    }
  }
`;
